import {
  MASTER_DATA,
  MASTER_DOCTOR_PREFIX,
  MASTER_GROUP_SPECIALTIES,
  MASTER_TAGS_AND_EVENTS,
  MASTER_APPS,
  MASTER_MANUALS,
  MASTER_FAQS,
  MASTER_SYMPTOM,
  MASTER_ORGAN,
  MASTER_ICD10,
  MASTER_UPDATE,
  MASTER_CLEAR
} from '../actions/types';

const initialState = {
  doctorPrefixs: [],
  groupSpecialties: [],
  tagsAndEvents: [],
  apps: [],
  manuals: [],
  faqs: [],
  symptoms: [],
  organs: [],
  icd10: []
};

export default function MasterReducer(state = initialState, action = {
  type: undefined
}) {
  switch (action.type) {
    case MASTER_DATA:
    case MASTER_DOCTOR_PREFIX:
    case MASTER_GROUP_SPECIALTIES:
    case MASTER_TAGS_AND_EVENTS:
    case MASTER_APPS:
    case MASTER_MANUALS:
    case MASTER_FAQS:
    case MASTER_SYMPTOM:
    case MASTER_ORGAN:
    case MASTER_ICD10:
    case MASTER_UPDATE:
      return { ...state, ...action.playload };
    case MASTER_CLEAR:
      return { ...state, status: undefined };
    default:
      return { ...state };
  }
}
